import React, { useEffect, useState } from "react";
import { BiShow } from "react-icons/bi";
import { BsArrowLeftCircleFill, BsToggles } from "react-icons/bs";
import { FaTrash } from "react-icons/fa";
import { MdCancel, MdModeEditOutline, MdPayment, MdTimer } from "react-icons/md";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import { Color } from "../../../../Utils/styles";
import {
  Day,
  fancyTimeFormat,
  getPosition,
  randomBetweenToNumber,
  renderPrice,
  ToDateJalali,
  ToTime,
  ToTimeJalali,
} from "../../Function";
import BoxShadow from "../BoxShadow";
import Loading from "../Loading";
import "./style.css";
import TableSearch from "./TableSearch";
import TableShowAs from "./TableShowAs";
import CustomModal from "../../Components/Modal/CustomModal";
const DataTable = props => {
  const emptyText = "ثبت نشده است";
  const [limit, setLimit] = useState(15);
  const [select, setSelect] = useState([]);
  const [areUSure, setAreUSure] = useState({
    status: false,
  });
  useEffect(() => {
    setAreUSure({ status: false });
  }, [props.loading]);

  const pagenate = () => {
    return (
      <div className="col-12 mt-4 mb-1">
        <div className="row justify-content-center">
          <Pagination
            activePage={props.data.current_page}
            itemsCountPerPage={limit}
            totalItemsCount={props.data.total}
            onChange={data => props.function(data, limit)}
            itemClass={"page-item"}
            linkClass={"page-link"}
          />
        </div>
      </div>
    );
  };

  const render = (value, td = { type: "" }, item) => {
    switch (td.type) {
      case "date":
        switch (td.timetype) {
          case "date-time":
            return ToTimeJalali(value) ? ToTimeJalali(value) : emptyText;
          case "time":
            return ToTime(value) ? ToTime(value) : emptyText;
          default:
            return ToDateJalali(value) ? ToDateJalali(value) : emptyText;
        }
      case "btn":
        return (
          <Link to={td.flink(item)} className={`btn btn-${td.colortype}`}>
            {value}
          </Link>
        );
      case "badge":
        return <span className={`badge bg-${td.colortype}`}>{value}</span>;
      case "price":
        return (
          <span>
            {fancyTimeFormat(value) ? fancyTimeFormat(value) : emptyText}
          </span>
        );
      case "icon":
        return <i className={value}></i>;
      case "image":
        return (
          <img
            style={{ width: td.size, height: td.size, objectFit: "cover" }}
            src={value}
            alt={td.type}
          />
        );
      case "limit":
        return value.substr(td.sl, td.el) + value.length < td.el ? null : "...";
      case "enum":
        return td.enum[value] ? td.enum[value] : emptyText;

      case "long":
        return getPosition(value, td.length ? td.length : 32);
      case "state":
        return td.method(item);
      case "dayname":
        return Day(value);
      case "unit":
        return value ? renderPrice(value) : "-";
      default:
        return value || value == 0
          ? value
          : td.textEmpty
            ? td.textEmpty
            : emptyText;
    }
  };

  const empty = () => {
    return (
      <td colSpan={props.heads.length + 1} style={{ textAlign: "center" }}>
        {props.props.textEmpty}
      </td>
    );
  };

  const getColor = (data) => {
    switch (data) {
      case "peyed":
        return '#00800036'
      case "waittopay":
        return '#ffff001f'
      case "null":
        return ''
      case "payerror":
        return '#ff000021'
      case "used":
        return '#80808047'
      default: {
        return ""
      }
    }
  }

  const renderIcon = type => {
    switch (type) {
      case "edit":
        return <MdModeEditOutline color="#a1a5b7" />;
      case "show":
        return <BiShow color="#a1a5b7" />;
      case "delete":
        return <FaTrash color="#a1a5b7" />;
      case "toggle":
        return <BsToggles color="#a1a5b7" />;
      case "go":
        return <BsArrowLeftCircleFill size={18} color="#a1a5b7" />;
      case "payment":
        return <MdPayment color="#a1a5b7" />;
      case "time":
        return <MdTimer color="#a1a5b7" />;
      case "cancle":
        return <MdCancel size={20} color="#a1a5b7" />;
      default:
        break;
    }
  };
  const showAs = () => {
    return (
      <TableShowAs
        limit={limit}
        setLimit={setLimit}
        set={v => {
          console.log();
          setLimit(props.data.current_page, v);
          props.function(props.data.current_page, v);
        }}
      />
    );
  };
  const getMainFunc = id => {
    let res = false;
    if (props.links) {
      props.links.map(link => {
        if (link.main) {
          link.function([id]);
        }
      });
    }
    return res;
  };
  const renderList = () => {
    
    if (props.list) {
      return props.list.map((item, i) => {
        if (props.short && i < 6) {
          return (
            <tr className="">
              <td
                className=""
                onClick={() => {
                  getMainFunc(item.id);
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "400",
                }}
              >
                {render(i + 1)}
              </td>
              {props.heads.map((td, i) => {
                if (!td.key) {
                  return (
                    <td
                      className=""
                      onClick={() => {
                        getMainFunc(item.id);
                      }}
                      style={{
                        cursor: "pointer",
                        fontWeight: "400",
                        fontSize: "12px",
                      }}
                    >
                      {render(item[i], td, item)}
                    </td>
                  );
                } else {
                  if (td.keyName) {
                    return (
                      <td
                        className=""
                        onClick={() => {
                          getMainFunc(item.id);
                        }}
                        style={{
                          cursor: "pointer",
                          fontWeight: "400",
                          fontSize: "12px",
                        }}
                      >
                        {render(
                          item[td.key] && item[td.key][td.keyName],
                          td,
                          item
                        )}
                      </td>
                    );
                  } else {
                    return (
                      <td
                        onClick={() => {
                          getMainFunc(item.id);
                        }}
                        style={{
                          cursor: "pointer",
                          fontWeight: "400",
                          fontSize: "12px",

                        }}
                        className=""
                      >
                        {render(item[td.key], td, item)}
                      </td>
                    );
                  }
                }
              })}{" "}
              <td className="">
                {props.links &&
                  props.links.map(link => {
                    if (link.type) {
                      return (
                        <button
                          onClick={() => {
                            link.function([item.id]);
                          }}
                          className="btn-table"
                          title={link.html}
                        >
                          {renderIcon(link.type)}
                        </button>
                      );
                    }
                  })}
              </td>
            </tr>
          );
        } else {
          return (
            <tr className="">
              <td
                className=""
                onClick={() => {
                  getMainFunc(item.id);
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "400",
                  background: props.bgTd && getColor(item.status)
                }}
              >
                {render(i + 1)}
              </td>
              {props.heads.map((td, i) => {

                if (!td.key && !td.keys) {
                  return (
                    <td
                      className=""
                      onClick={() => {
                        getMainFunc(item.id);
                      }}
                      style={{
                        cursor: "pointer",
                        fontWeight: "400",
                        fontSize: "12px",
                        background: props.bgTd && getColor(item.status)
                      }}
                    >
                      {render(item[i], td, item)}
                    </td>
                  );
                } else {
                  if (td.keyName) {
                    return (
                      <td
                        className=""
                        onClick={() => {
                          getMainFunc(item.id);
                        }}
                        style={{
                          cursor: "pointer",
                          fontWeight: "400",
                          fontSize: "12px",
                          background: props.bgTd && getColor(item.status)
                        }}
                      >
                        {render(
                          item[td.key] && item[td.key][td.keyName],
                          td,
                          item
                        )}
                      </td>
                    );
                  } else {
                    return (
                      <td
                        onClick={() => {
                          getMainFunc(item.id);
                        }}
                        style={{
                          cursor: "pointer",
                          fontWeight: "400",
                          fontSize: "12px",
                          background: props.bgTd && getColor(item.status)
                        }}
                        className=""
                      >
                        {
                          td.multiVal
                            ? td.keys.map(data => (
                              item[data.key] &&
                              <span className={td.keysClass}>
                                {data.text + render(item[data.key], td, item)}
                              </span>
                            ))
                            : render(item[td.key], td, item)
                        }
                      </td>
                    );
                  }
                }
              })}{" "}
              <td className="" style={{ background: props.bgTd && getColor(item.status) }}>
                {props.links &&
                  props.links.map(link => {
                    if (link.type) {
                      return (
                        <button
                          onClick={() => {
                            if (link.type == "delete") {
                              setAreUSure({
                                status: true,
                                id: item.id,
                                func: link.function,
                              });
                            }
                            else if (link.showRole) {
                              link.function([item.id], item.user_role);
                            }
                            else {
                              link.function([item.id]);
                            }
                          }}
                          className="btn-table"
                          title={link.html}
                        >
                          {renderIcon(link.type)}
                        </button>
                      );
                    }
                  })}
              </td>
            </tr >
          );
        }
      });
    } else {
      return empty();
    }
  };

  const renderHead = () => {
    if (props.heads) {
      return props.heads.map((head, i) => {
        return (
          <th className=""
            style={{
              fontSize: "14px",
              fontWeight: "500",
              whiteSpace: "nowrap",
            }}
          >
            {head.title}
          </th>
        );
      });
    }
  };
  const search = () => {
    return (
      props.multiSearch
        ? <div className="row">
          {props.search.map(item => (
            <div className={"mb-2 " + (item.size)} >
              <TableSearch label={item.label} search={item.fn} />
            </div>
          ))
          }
        </div>
        : <div className="col-12" style={{ padding: 0, margin: 0 }}>
          <TableSearch search={props.search} />
        </div>

    );
  };
  const links = links => {
    if (links) {
      return (
        <div className="row justify-content-end align-items-end">
          {links.map((link, i) => {
            if (!link.type) {
              if (link.typeLink == "div") {
                return <div className={`my-2 ${link.size}`}>{link.html}</div>;
              } else {
                return (
                  <div className={`my-2 ${link.size}`}>
                    <button
                      disabled={
                        link.undisabled
                          ? false
                          : select.length >= 1
                            ? link.multi
                              ? false
                              : select.length == 1
                                ? false
                                : true
                            : true
                      }
                      className={`btn btn-${select.length > 1
                        ? link.multi
                          ? link.color
                          : "dark"
                        : link.color
                        }`}
                      style={{
                        whiteSpace: "nowrap",
                      }}
                      onClick={() => {
                        this.HandlerLink(link);
                      }}
                    >
                      {link.html}
                    </button>
                  </div>
                );
              }
            }
          })}
        </div>
      );
    }
  };
  const renderState = () => {
    if (props.loading) {
      return <Loading count={2} />;
    } else {
      if (!props.list || props.list.length == 0) {
        return (
          <div className=" d-flex rounded  justify-content-center py-3 rounded flex-column align-items-center ">
            <img
              width={256}
              height={256}
              src={window.origin + "/img/empty.png"}
              className="img-empty"
            />

            <h5 className="text-center alert  " style={{ flex: 1 }}>
              {props.textEmpty}
            </h5>
          </div>
        );
      } else {
        return (
          <table
            className="table  table-hover text-center"
            style={{
              overflowX: "scroll",
            }}
          >
            <thead
              style={{
                // background: "#36304a",
                color: "#fff",
              }}
              className="thead-primary table-gradiant "
            >
              <tr>
                <th className="">ردیف</th>
                {renderHead()}
                <th className=""></th>
              </tr>
            </thead>
            <tbody>{renderList()}</tbody>
          </table>
        );
      }
    }
  };
  return (
    <div className="col-12">
      {props.short ? (
        <></>
      ) : (
        <BoxShadow
          style={{
            padding: "10px",
            marginBottom: "20px",
          }}
        >
          <div className={"row " + (props.textbtn && "mb-4")} style={{}}>
            <div className={props.textbtn ? "col-6" : "col-12 text-center"}>
              <h5>{props.header}</h5>
            </div>
            {props.textbtn ? (
              <div className="col-6 text-right">
                <Link to={props.linkbtn} className="btn btn-primary text-white">
                  {props.textbtn}
                </Link>
              </div>
            ) : null}
          </div>
          <div className="row justify-content-end align-items-center  ">
            <div className={"col-12 mb-2 " + (props.links ? "col-md-4" : "col-md-10")}>
              {!props.needSearch && search(props.search)}
            </div>

            {props.links && <div className="col-md-6 col-12">{links(props.links)}</div>}

            <div className="col-md-2 col-2 d-flex justify-content-end" >
              {showAs()}
            </div>
          </div>
        </BoxShadow>
      )}

      <BoxShadow
        style={{
          borderRadius: "10px",
          padding: 0,
          overflowX: "scroll",
        }}
      >
        {renderState()}
      </BoxShadow>
      {props.short ? (
        <></>
      ) : !props.list || props.list.length == 0 ? (
        ""
      ) : (
        !props.paginateUse && props.data && pagenate()
      )}
      <CustomModal
        handleClose={() => {
          setAreUSure({ status: false });
        }}
        show={areUSure.status}
        header="آیا مطمئن هستید؟؟"
      >
        <p style={{ fontWeight: "400" }}>
          حذف برخی اطلاعات پنل باعث از کار افتادن سامانه میشود
        </p>
        <div className="d-flex ">
          {" "}
          <button
            className="btn btn-primary"
            onClick={() => {
              areUSure.func && areUSure.func([areUSure.id]);
            }}
          >
            بله
          </button>
          <button
            className="btn btn-success mr-2"
            onClick={() => {
              setAreUSure({ status: false });
            }}
          >
            خیر
          </button>
        </div>
      </CustomModal>
    </div>
  );
};

export default DataTable;
